<template>
    <div>
        <label for="provincias">{{ $t('formularios.provincia') }}</label>
        <ValidationProvider name="provincias" id="provincias" rules="required" v-slot="{ errors }">
            <multiselect
                :disabled="desactivar"
                v-model="selected"
                :placeholder="$t('formularios.provincia')"
                label="nombre"
                track-by="id"
                :options="provincias"
                :multiple="false"
                v-on:select="(selectedOpt) => $emit('selected', selectedOpt)"
            ></multiselect>
            <span v-if="errors[0]" class="error invalid-feedback" style="display: block;">{{ errors[0] }}</span>
        </ValidationProvider>
    </div>
</template>

<script>

export default {
    props: ['provincia', 'errors', 'pais', 'desactivar'],
    data() {
        return {
            provincias: [],
            selected: null
        }
    },
    watch: {
        pais() {
            if(this.pais) this.getProvincias();
        }
    },
    created() {
        this.getProvincias();

        if(this.provincia) {
            this.selected = this.provincia;
        }
    },
    methods: {
        getProvincias() {
            const data = {
                filters: {
                    pais_id: this.pais ?? 0
                }
            };

            this.$store.dispatch(this.config.getVuexAlias('select.provincias'), data).then(res => {
                this.provincias = res.data.data;
            });
        }
    }
}
</script>
